import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import CalendarEventData from '../store/schema/CalendarEventData';
import datapoints from '../datapoints';
import { action } from 'satcheljs';
import { ClientFolderId } from 'owa-client-ids';
import { addDatapointConfig } from 'owa-analytics-actions';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { OwaDate } from 'owa-datetime';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';

export const openSchedulingAssistant = action(
    'OPEN_SCHEDULING_ASSISTANT',
    (isProposeNewTime: boolean) =>
        addDatapointConfig(datapoints.openSchedulingAssistant, {
            isProposeNewTime,
        })
);

export const closeSchedulingAssistant = action(
    'CLOSE_SCHEDULING_ASSISTANT',
    (
        isProposeNewTime: boolean,
        finalState?: CalendarEventData,
        isAllDayEventExplicitlySet?: boolean
    ) => {
        let attendeeCount = 0;
        if (finalState) {
            attendeeCount += finalState.RequiredAttendees ? finalState.RequiredAttendees.length : 0;
            attendeeCount += finalState.OptionalAttendees ? finalState.OptionalAttendees.length : 0;
        }
        return addDatapointConfig(
            {
                name: 'CLOSE_SCHEDULING_ASSISTANT',
                customData: {
                    isSave: !!finalState,
                    attendeeCount: attendeeCount,
                    isProposeNewTime: isProposeNewTime,
                },
            },
            {
                finalState,
                isAllDayEventExplicitlySet,
            }
        );
    }
);

export const initializeSchedulingAssistant = action(
    'INITIALIZE_SCHEDULING_ASSISTANT',
    (
        Start: OwaDate,
        End: OwaDate,
        IsAllDayEvent: boolean,
        OriginalEventStart: OwaDate,
        OriginalEventEnd: OwaDate,
        OriginalEventIsAllDayEvent: boolean,
        RequiredAttendees: AttendeeType[],
        OptionalAttendees: AttendeeType[],
        Resources: AttendeeType[],
        Organizer: AttendeeType,
        IsOrganizer: boolean,
        IsProposeNewTime: boolean,
        IsAcceptProposeNewTime: boolean,
        canModifyAttendees: boolean,
        colorScheme: ColorScheme,
        Recurrence: RecurrenceType,
        ParentFolderId: ClientFolderId,
        shouldAdjustStartTimeEndTime: boolean,
        isAllDayEventExplicitlySet: boolean
    ) => ({
        Start,
        End,
        IsAllDayEvent,
        OriginalEventStart,
        OriginalEventEnd,
        OriginalEventIsAllDayEvent,
        RequiredAttendees,
        OptionalAttendees,
        Resources,
        Organizer,
        IsOrganizer,
        IsProposeNewTime,
        IsAcceptProposeNewTime,
        canModifyAttendees,
        colorScheme,
        Recurrence,
        ParentFolderId,
        shouldAdjustStartTimeEndTime,
        isAllDayEventExplicitlySet,
    })
);
